import { createReducer, Action, on } from '@ngrx/store';

import { ChecklistActions } from './checklist.actions';
import { ChecklistState } from './checklist.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: ChecklistState = {
  loading: false,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      ChecklistActions.LoadModel,
      (state): ChecklistState => ({
        ...state,
        loading: true,
        error: undefined,
        checklist: undefined,
      })
    ),
    on(
      ChecklistActions.LoadModelSuccess,
      (state, action): ChecklistState => ({ ...state, loading: false, checklist: action.checklist })
    ),
    on(
      ChecklistActions.SaveModel,
      (state): ChecklistState => ({ ...state, loading: true, error: undefined })
    ),
    on(
      ChecklistActions.SaveModelSuccess,
      (state, action): ChecklistState => ({ ...state, loading: false, checklist: action.checklist })
    ),
    on(
      ChecklistActions.LoadModelFail,
      ChecklistActions.SaveModelFail,
      (state, action): ChecklistState => ({
        ...state,
        loading: false,
        error: action.error,
        checklist: undefined,
      })
    )
  )
);

export function reducer(state: ChecklistState | undefined, action: Action) {
  return featureReducer(state, action);
}
